import { Command, HttpMethod } from "~/extensions/api";
export class GetHanyoListCommand extends Command {
    constructor(getHanyoParams) {
        super(HttpMethod.Get, "common/hanyo");
        this.getHanyoParams = getHanyoParams;
    }
    getHanyoParams = [];
}
export class GetHanyoParam {
    /* eslint-disable-next-line max-params */
    constructor(hanyoKb = null, option1 = "", option2 = "", option3 = "", option4 = "", option5 = "") {
        this.hanyoKb = hanyoKb;
        this.option1 = option1;
        this.option2 = option2;
        this.option3 = option3;
        this.option4 = option4;
        this.option5 = option5;
    }
    hanyoKb = null;
    option1 = "";
    option2 = "";
    option3 = "";
    option4 = "";
    option5 = "";
}
